import { Component, OnInit } from '@angular/core';
import { ItemModifierService } from "../ApplicationServices/ItemModifierServices";
import { UserInfoStore } from "../shared/store/userInfo.store";
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";

@Component({
  selector: 'app-thankingyou',
  templateUrl: './thankingyou.component.html',
  styleUrls: ['./thankingyou.component.scss']
})
export class ThankingyouComponent implements OnInit {

  constructor
  (

    private infoStore: UserInfoStore,
    private itemModifierService: ItemModifierService,
    private router: Router,

  ) { }

  ngOnInit(): void {

   //this.PlaceOrder();

   if( sessionStorage.getItem("ProceedPay_Id")=="1" ){

    this.infoStore.setCartInfo([]);
    sessionStorage.clear();
    this.infoStore.setInfo({});

   //alert("Session Expired , Please Login  !!");
     //this.router.navigateByUrl("login");

   }

  }



  PlaceOrder(){

    //  this.generateForm.value.CurrentAmount;

    if (sessionStorage.getItem("OrderMaster_Id")) {
      var item = {
        Id: 0,
        OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
         //CreatedBy: Number(sessionStorage.getItem("UID")), this.PaymentForm.get('OrderPaymentTypeId').value
        //OrderPaymentTypeId: this.PaymentForm.get('OrderPaymentTypeId').value,
        OrderPaymentTypeId: sessionStorage.getItem("RazorPID"),
        OperationType: "order placed",
        RazorOrderId: sessionStorage.getItem("RazorOrder_Id"),
        RazorPaymentId: sessionStorage.getItem("RazorPayment_Id"),

           //  sessionStorage.getItem("RazorOrder_Id");
          // sessionStorage.getItem("RazorPayment_Id");


      };
      this.itemModifierService.addItemToCart(item).subscribe((event) => {
        if (event) {

          console.log(event);
           this.getCartInfo();

        }
      });
    } else {
      alert("Please Login");
      this.router.navigateByUrl("login");
    }

  }


  getCartInfo() {

    if (sessionStorage.getItem("OrderMaster_Id")) {
      this.itemModifierService
        .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.infoStore.setCartInfo(event);
          } else {
            this.infoStore.setCartInfo([]);
          }
        });
    }
    else {
      this.infoStore.setCartInfo([]);
    }

  }



}
